import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface SectionAction {
  id: string;
  label: string;
  icon: string;
  primary?: boolean;
  disabled?: boolean;
}

@Component({
  selector: 'app-editable-section',
  templateUrl: './editable-section.component.html',
  styleUrls: ['./editable-section.component.scss']
})
export class EditableSectionComponent {
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() icon: string = '';
  @Input() loading: boolean = false;
  @Input() error: string = '';
  @Input() actions: SectionAction[] = [];
  @Input() showActions: boolean = true;
  @Input() elevated: boolean = true;
  @Input() data: any = null;

  @Output() actionClicked = new EventEmitter<string>();

  onActionClick(actionId: string): void {
    this.actionClicked.emit(actionId);
  }
}